import { cn, dynamicStyling, resolveColor } from 'styles';
import { IconProps } from '../types';

export function CardsIcon({ color = 'currentColor', className, size = 18 }: IconProps) {
  return (
    <svg
      stroke={resolveColor(color)}
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 256 256"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...dynamicStyling({
        size,

        className: cn('shrink-0 text-inherit', className),
      })}
    >
      <path d="M184,72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V88A16,16,0,0,0,184,72Zm0,128H40V88H184V200ZM232,56V176a8,8,0,0,1-16,0V56H64a8,8,0,0,1,0-16H216A16,16,0,0,1,232,56Z"></path>
    </svg>
  );
}
